import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Vehicles() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ make: "", model: "", year: "", plate: "", notes: "" });
  const [show, setShow] = useState(false);

  const load = async () => {
    const { data } = await api.get("/vehicles");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/vehicles", {
        ...form,
        year: form.year ? Number(form.year) : null,
      });
      setForm({ make: "", model: "", year: "", plate: "", notes: "" });
      setShow(false);
      toast.success("Vehicle added");
      load();
    } catch (e) {
      toast.error("Failed");
    }
  };

  const remove = async (id) => {
    await api.delete(`/vehicles/${id}`);
    toast.success("Removed");
    load();
  };

  return (
    <div>
      <div className="px-6 pt-6 pb-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate(-1)} data-testid="vehicles-back-btn"><ArrowLeft /></button>
          <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#9CA3AF] font-display">My Vehicles</span>
        </div>
        <button onClick={() => setShow(!show)} data-testid="add-vehicle-btn" className="h-9 px-3 bg-[#3CFF7E] text-[#0A0A0A] rounded-md flex items-center gap-1 text-sm font-bold">
          <Plus size={14} /> {show ? "Close" : "Add"}
        </button>
      </div>

      <div className="px-6 mb-4">
        <h1 className="font-display text-3xl font-black tracking-tight">Your Vehicles</h1>
      </div>

      {show && (
        <form onSubmit={add} className="px-6 mb-6 space-y-3 border-t border-b border-white/10 py-4">
          <div className="grid grid-cols-2 gap-2">
            <input required value={form.make} onChange={(e) => setForm({ ...form, make: e.target.value })} placeholder="Make" data-testid="vehicle-make" className="h-12 border border-white/20 rounded-md px-3" />
            <input required value={form.model} onChange={(e) => setForm({ ...form, model: e.target.value })} placeholder="Model" data-testid="vehicle-model" className="h-12 border border-white/20 rounded-md px-3" />
            <input type="number" value={form.year} onChange={(e) => setForm({ ...form, year: e.target.value })} placeholder="Year" data-testid="vehicle-year" className="h-12 border border-white/20 rounded-md px-3" />
            <input value={form.plate} onChange={(e) => setForm({ ...form, plate: e.target.value })} placeholder="Plate" data-testid="vehicle-plate" className="h-12 border border-white/20 rounded-md px-3" />
          </div>
          <input value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} placeholder="Notes" data-testid="vehicle-notes" className="w-full h-12 border border-white/20 rounded-md px-3" />
          <button type="submit" data-testid="save-vehicle-btn" className="w-full h-12 bg-[#3CFF7E] text-[#0A0A0A] font-display font-bold uppercase tracking-wider rounded-md">Save Vehicle</button>
        </form>
      )}

      <div className="px-6 pb-6 space-y-2">
        {items.length === 0 ? (
          <div className="text-sm text-[#9CA3AF] border border-dashed border-white/20 rounded-md p-8 text-center">
            No vehicles yet. Add your first one.
          </div>
        ) : (
          items.map((v) => (
            <div key={v.id} className="border border-white/10 rounded-md p-4 flex justify-between items-start" data-testid={`vehicle-${v.id}`}>
              <div>
                <div className="font-display font-bold">{v.make} {v.model}</div>
                <div className="text-xs text-[#9CA3AF]">{v.year} {v.plate && `· ${v.plate}`}</div>
                {v.notes && <div className="text-xs text-[#9CA3AF] mt-1">{v.notes}</div>}
              </div>
              <button onClick={() => remove(v.id)} data-testid={`delete-${v.id}`} className="text-[#9CA3AF] hover:text-[#F87171]">
                <Trash2 size={16} />
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
